import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation acceptImportsMutation($importPks: [Int]) {
    acceptImports(importPks: $importPks) {
      ok
      error {
        statusCode
      }
      redirectUrl
    }
  }
`;

const acceptImports = (environment, variables, callback) => {
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};

export default acceptImports;
